import * as React from "react";
import { styled, alpha } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import InputBase from "@mui/material/InputBase";
import Badge from "@mui/material/Badge";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import MessageIcon from '@mui/icons-material/Message';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import NotificationsIcon from "@mui/icons-material/Notifications";
import MoreIcon from "@mui/icons-material/MoreVert";
import SidebarMobileComponent from "./SidebarMobileComponent";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../services/firebase";
import { useAuthStore } from "../../context/useAuthStore";

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(3),
    width: "auto",
  },
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "20ch",
    },
  },
}));

export default function HeaderComponent() {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] =
    React.useState<null | HTMLElement>(null);

  const [sidebarOpen, setSidebarOpen] = React.useState(false);

  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const { WorkerData, logout }: any = useAuthStore();

  //Cantidad de codigos Otp no validados
  const [cantidadOtpsNoValidados, setCantidadOtpsNoValidados] =
    React.useState(0);
  React.useEffect(() => {
    obtenerCantidadOtps();
    obtenerCantidadSolicitudesNuevosSocios();
  }, []);
  const obtenerCantidadOtps = async () => {
    {
      try {
        const otpSnapshot = await getDocs(collection(db, "otpsRegisterSocios"));
        const otpList = otpSnapshot.docs.map((doc) => doc.data());
        setCantidadOtpsNoValidados(otpList.length);
      } catch (error) {
        console.log(
          "Error al obtener la cantidad de OTPs no validados:",
          error
        );
      }
    }
  };

  //Cantidad de solicitudes de nuevos socios
  const [cantidadSolicitudesNuevosSocios, setCantidadSolicitudesNuevosSocios] =
    React.useState(0);

  const obtenerCantidadSolicitudesNuevosSocios = async () => {
    {
      try {
        const solicitudesSnapshot = await getDocs(
          collection(db, "solicitudesNewSocios")
        );
        const solicitudesList = solicitudesSnapshot.docs.map((doc) => doc.data());
        setCantidadSolicitudesNuevosSocios(solicitudesList.length);
      } catch (error) {
        console.log(
          "Error al obtener la cantidad de solicitudes de nuevos socios:",
          error
        );
      }
    }
  };

  //Manejo del sidebar
  const handleSidebarOpen = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };
  const handleLogout = () => {
    // Lógica para cerrar sesión
    logout();
    handleMenuClose();
  };

  const handleMobileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const menuId = "primary-search-account-menu";
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem onClick={handleMenuClose}>Perfil</MenuItem>
      <MenuItem onClick={handleLogout}>Cerrar sesión</MenuItem>
    </Menu>
  );

  const mobileMenuId = "primary-search-account-menu-mobile";
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MenuItem>
        <IconButton size="large" aria-label="Mira nuevas solicitudes" color="inherit">
          <Badge badgeContent={cantidadOtpsNoValidados} color="error">
            <MessageIcon />
          </Badge>
        </IconButton>
        <p>Códigos OTP</p>
      </MenuItem>
      <MenuItem>
        <IconButton
          size="large"
          aria-label="show 17 new notifications"
          color="inherit"
        >
          <Badge badgeContent={cantidadSolicitudesNuevosSocios} color="error">
            <PersonAddIcon />
          </Badge>
        </IconButton>
        <p>Nuevas Solicitudes</p>
      </MenuItem>
      <MenuItem onClick={handleProfileMenuOpen}>
        <IconButton
          size="large"
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
        >
          <AccountCircle />
        </IconButton>
        <p>Perfil</p>
      </MenuItem>
    </Menu>
  );

  return (
    <>
      <SidebarMobileComponent open={sidebarOpen} setOpen={setSidebarOpen} />
      <Box sx={{ flexGrow: 1 }}>
        <AppBar position="static">
          <Toolbar>
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              aria-label="open drawer"
              sx={{ mr: 2 }}
              onClick={handleSidebarOpen}
            >
              <MenuIcon />
            </IconButton>
            <Typography
              variant="h6"
              noWrap
              component="div"
              sx={{ display: { xs: "none", sm: "block" } }}
            >
              Sistema de Gestión de Aplicativo Móvil Todos los Santos de Chota
            </Typography>

            <Box sx={{ flexGrow: 1 }} />
            <Box sx={{ display: { xs: "none", md: "flex" } }}>
              <IconButton
                size="large"
                aria-label="Códigos OTP no validados"
                color="inherit"
              >
                <Badge badgeContent={cantidadOtpsNoValidados} color="error">
                  <MessageIcon />
                </Badge>
              </IconButton>
              <IconButton
                size="large"
                aria-label="Mira nuevas solicitudes"
                color="inherit"
              >
                <Badge badgeContent={cantidadSolicitudesNuevosSocios} color="error">
                  <PersonAddIcon />
                </Badge>
              </IconButton>
              <h5 className="text-white me-3 ms-3 mt-2">{WorkerData?.email}</h5>
              <IconButton
                size="large"
                edge="end"
                aria-label="account of current user"
                aria-controls={menuId}
                aria-haspopup="true"
                onClick={handleProfileMenuOpen}
                color="inherit"
              >
                <AccountCircle />
              </IconButton>
            </Box>
            <Box sx={{ display: { xs: "flex", md: "none" } }}>
              <IconButton
                size="large"
                aria-label="show more"
                aria-controls={mobileMenuId}
                aria-haspopup="true"
                onClick={handleMobileMenuOpen}
                color="inherit"
              >
                <MoreIcon />
              </IconButton>
            </Box>
          </Toolbar>
        </AppBar>
        {renderMobileMenu}
        {renderMenu}
      </Box>
    </>
  );
}
